// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4j-0";
export var orangeButton = "_4j-1";